const routes = [
    {
        path: '/cte/tributos',
        alias: ['/cte/tributos/index'],
        component: () => import('../views/Listar')
    },
    {
        path: '/cte/tributos/adicionar',
        component: () => import('../views/Adicionar')
    },
    {
        path: '/cte/tributos/editar/:id',
        component: () => import('../views/Editar')
    },
    {
        path: '/cte/tributos/visualizar/:id',
        component: () => import('../views/Visualizar')
    },
]

export default routes